<template>
  <div>
    <a-modal v-model="visible" :closable="false" :footer="false" width="90vw" centered @cancel="onModalClose">
      <a-tabs v-model="activeKey" type="card" tab-position="top" @change="onTabChange">
        <a-tab-pane v-for="item in serviceList" :key="item.service_name" :tab="item.service_name" />
      </a-tabs>
      <a-spin :spinning="loading" tip="加载中...">
        <div class="container">
          <div class="file-container container-card">
            <div style="width: 100%; margin-bottom: 8px;display: flex;align-items: center">
              <a-select v-model="choseRelease" placeholder="选择想要对比的镜像" style="width: 100%" allow-clear show-search :filter-option="false" @search="onSearch" @change="handleChange">
                <a-select-option v-for="(release, index) in filterItems" :key="index" :value="release.id">
                  <a-tag :color="releaseStatus[release.status].color">{{ releaseStatus[release.status].label }}</a-tag>
                  <span>{{ release.title }}</span>
                </a-select-option>
              </a-select>
              <a-popconfirm
                v-if="llm_order === 0"
                title="确定触发/重新获取改动代码分析?"
                ok-text="确定"
                cancel-text="取消"
                placement="bottom"
                @confirm="doCodeAnalyse"
              >
                <svg-icon type="ai" style="font-size: 38px;margin-left: 6px" />
              </a-popconfirm>
              <a-popover v-if="llm_order > 0" placement="bottom">
                <template slot="content">
                  <div class="ai-loading-container">
                    <div class="ai-loading">
                      <div class="ai-circle" />
                      <div class="ai-circle" />
                      <div class="ai-circle" />
                      <div class="ai-pulse" />
                    </div>
                    <span class="ai-text">代码分析中，前面还有{{ llm_order }}个任务在处理...</span>
                  </div>
                </template>
                <svg-icon type="ai" style="font-size: 38px;margin-left: 6px" />
              </a-popover>
            </div>
            <div v-if="alertMessage === null" class="file-tree">
              <el-tree v-if="fileTree" :data="fileTree" :default-expand-all="true" highlight-current>
                <template #default="{ node, data }">
                  <span class="custom-tree-node father">
                    <span class="node-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="iconClass(data.type)" />
                      </svg>
                    </span>
                    <a-popover v-if="data.analyse" placement="right" trigger="hover">
                      <template slot="content">
                        <div style="width: 400px;height: 200px;white-space: pre-line; overflow-y: auto;">
                          {{ data.analyse }}
                        </div>
                      </template>
                      <span class="node-title" :style="titleStyle(node, data)" @click="fileClick(data, node)">
                        {{ node.label }}
                      </span>
                    </a-popover>
                    <span v-else class="node-title" :style="titleStyle(node, data)" @click="fileClick(data, node)">
                      {{ node.label }}
                    </span>
                    <a-tooltip
                      v-if="data.analyse && data.analyse.includes('疑似夹带') && data.type !== 'folder'"
                      class="suspect-flag"
                      placement="top"
                      title="疑似夹带"
                    >
                      <a-icon type="exclamation-circle" theme="filled" :style="{ color: '#faad14', fontSize: '12px', marginRight: '6px' }" />
                    </a-tooltip>
                    <span class="create-line" @click="onCodeDiff(data)">{{ data.type === 'folder' ? '' : '+' }}{{ data.create_line }}</span>
                    <span class="delete-line" @click="onCodeDiff(data)">{{ data.type === 'folder' ? '' : '-' }}{{ data.delete_line }}</span>
                  </span>
                </template>
              </el-tree>
            </div>
            <div v-else style="flex: 1; height: 100%">
              <a-empty style="margin-top: 120px" :description="alertMessage" />
            </div>
          </div>
          <div class="graph-container container-card">
            <relation-graph v-if="hasData" ref="seeksRelationGraph" :options="graphOptions" :on-node-click="onNode" :on-line-click="onLine">
              <div slot="node" slot-scope="{ node }">
                <a-badge v-if="node.data.type === 'Function'">
                  <a-icon slot="count" theme="filled" :type="node.data.case_cover ? 'check-circle' : 'exclamation-circle'" :style="{ color: node.data.case_cover ? '#67C23A' : '#F56C6C' }" />
                  <a-popover placement="right" trigger="hover">
                    <template slot="content">
                      <div style="max-height: calc(80vh); overflow-y: auto; padding: 6px">
                        <div v-for="row in node.data.content.split('\n')" :key="row.index">
                          <div :style="rowStyle(node, row)">{{ row }}</div>
                        </div>
                      </div>
                    </template>
                    <div class="node-style">{{ node.text }}</div>
                  </a-popover>
                </a-badge>
                <div v-else class="node-style">{{ node.text }}</div>
              </div>
            </relation-graph>
            <div v-else style="margin-top: 200px">{{ msg }}</div>
          </div>
          <div class="api-container container-card">
            <div v-for="item in apiList" :key="item.index" class="api-item" @mouseenter="showGenerateCase(item)" @mouseleave="hideGenerateCase(item)">
              <a-tag :color="high_light_api_list.indexOf(item) > -1 ? '#2db7f5' : 'blue'" class="tag" @click="copyPath(item)">
                {{ item }}
              </a-tag>
              <a-button
                v-if="hoveredApi === item"
                type="primary"
                size="small"
                class="generate-case-btn"
                @click="generateCase(item)"
              >
                生成集成case
              </a-button>
            </div>
            <a-tag v-for="item in grpcList" :key="item.index" :color="high_light_grpc_list.indexOf(item) > -1 ? '#4da628' : 'green'" class="tag" @click="copyPath(item)">
              {{ item }}
            </a-tag>
          </div>
        </div>
      </a-spin>
    </a-modal>
    <a-modal v-model="modalVisible" width="80vw" centered :footer="null" :body-style="{ height: '80vh', 'overflow-y': 'auto' }">
      <template slot="title">
        <a-radio-group v-model="diffType" size="small">
          <a-radio-button value="line-by-line">行</a-radio-button>
          <a-radio-button value="side-by-side">列</a-radio-button>
        </a-radio-group>
      </template>
      <git-diff-code v-if="Object.keys(diff).length > 0" :value="diff.content" :path="diff.path" :output-format="diffType" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { releaseStatus } from '@/utils/dictionary';
import { releaseServiceList, choose2Acc } from '@/api/project/workflow';

import RelationGraph from 'relation-graph';
import Accurate from '@/api/project/accurate';
import GitDiffCode from '@/components/GitDiffCode';

export default {
  components: { RelationGraph, GitDiffCode },
  props: {},
  data() {
    return {
      releaseStatus,
      serviceList: [],
      activeKey: null,
      serviceId: null,
      spinning: false,
      loading: false,
      visible: false,
      alertMessage: null,
      hasData: false,
      msg: null,
      fileTree: [], // 文件树
      apiList: [],
      grpcList: [],
      llm_order: 0,
      high_light_api_list: [],
      high_light_grpc_list: [],
      hoveredApi: null,
      filterItems: [],
      choseRelease: null,
      filterForm: {
        title: null
      },
      modalVisible: false,
      diffType: 'side-by-side',
      diff: {
        old_content: '',
        new_content: '',
        file_path: ''
      },
      graphOptions: {
        layouts: [
          {
            label: '中心',
            layoutName: 'tree',
            layoutClassName: 'seeks-layout-center',
            defaultJunctionPoint: 'border',
            defaultLineShape: 1,
            centerOffset_x: 500, // 根节点x轴偏移量
            from: 'right',
            min_per_width: 150,
            max_per_width: 200, // 节点纵向距离
            max_per_height: 80 // 节点纵向距离
          }
        ],
        disableDragNode: true, // 禁用节点拖拽
        defaultNodeShape: 1,
        defaultNodeWidth: 100,
        defaultNodeHeight: 40,
        allowSwitchLineShape: false,
        allowSwitchJunctionPoint: false,
        defaultJunctionPoint: 'border',
        moveToCenterWhenResize: false,
        allowShowMiniToolBar: true, // 禁用工具栏
        disableZoom: false, // 禁用缩放
        defaultNodeBorderWidth: 1
      }
    };
  },
  computed: {
    /**
     * 计算标题样式
     */
    titleStyle() {
      return (node, data) => {
        if (!data.status) {
          return;
        }
        switch (data.status) {
          case 1:
            return 'color:#1E90FF';
          case 2:
            return 'color:#13CD54';
          case 3:
            return 'color:#909399;text-decoration:line-through';
          case 4:
            return 'color:#FF4500';
        }
      };
    },
    iconClass() {
      return val => {
        const fileTypeList = ['folder', 'go', 'vue', 'png', 'css', 'html', 'js'];
        if (fileTypeList.indexOf(val) > -1) {
          return '#icon-' + val;
        } else {
          return '#icon-unknown.svg';
        }
      };
    },
    /**
     * 行样式
     * @param {*} node
     * @param {*} row
     */
    rowStyle(node, row) {
      return (node, row) => {
        const defaultCss = 'white-space:pre-wrap;';
        if (node.targetTo.length === 0) {
          return defaultCss;
        }
        return node.targetTo.some(item => {
          const reg = new RegExp(`\\W(${item.data.name})\\W`, 'g');
          const r = row.match(reg);
          return r !== null;
        })
          ? defaultCss + 'color:#2db7f5'
          : defaultCss;
      };
    }
  },
  methods: {
    /**
     * 打开精准分析模态框
     * @param {*} workflowId
     * @param {*} services
     */
    open(workflowId, services) {
      this.visible = true;
      this.choseRelease = null;
      this.workflowId = workflowId;
      this.serviceList = services;
      this.activeKey = services[0].service_name;
      this.serviceId = services[0].service_id;
      this.getAccInfo();
      this.getReleaseList();
    },

    /**
     * 获取精准分析信息
     */
    async getAccInfo() {
      this.loading = true;
      const res = await Accurate.getTwoDiff({
        workflow_id: this.workflowId,
        service_name: this.activeKey
      });
      this.fileTree = [];
      this.apiList = [];
      this.grpcList = [];
      this.alertMessage = res.em === 'success' ? null : res.em;
      this.hasData = res.status;
      this.loading = false;
      this.fileTree = res.online.fileTree;
      this.llm_order = res.online.order;
      if (this.hasData) {
        this.apiList = res.online.apiList;
        this.grpcList = res.online.grpcList;
        this.$nextTick(() => {
          this.$refs.seeksRelationGraph.setJsonData(res.online.graph, () => {
            // 渲染后的逻辑处理
          });
        });
      } else {
        this.msg = res.msg;
      }
    },

    handleChange() {
      this.loading = true;
      if (!this.choseRelease) {
        this.getAccInfo();
        return;
      }
      this.utils.trackClick({ name: '切换精准镜像' });
      this.alertMessage = null;
      this.fileTree = [];
      this.apiList = [];
      this.grpcList = [];
      choose2Acc({ workflow_id: this.workflowId, release_id: this.choseRelease, service_name: this.activeKey })
        .then(res => {
          this.loading = false;
          if (res.data.em !== 'success') {
            this.alertMessage = res.data.em;
            this.$nextTick(() => {
              this.$refs.seeksRelationGraph.setJsonData([], () => {
                // 渲染后的逻辑处理
              });
            });
            return;
          }
          const online = Accurate.graphDataBuild(res.data.online);
          this.apiList = online.apiList;
          this.grpcList = online.grpcList;
          this.fileTree = online.fileTree;
          this.$refs.seeksRelationGraph.setJsonData(online.graph, () => {
            // 渲染后的逻辑处理
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onSearch: debounce(function (value) {
      this.filterForm.title = value;
      this.getReleaseList();
    }, 500),

    getReleaseList() {
      this.filterItems = [];
      releaseServiceList({ workflow_id: this.workflowId, service_id: this.serviceId, title: this.filterForm.title })
        .then(res => {
          this.filterItems = res.data.items;
        })
        .catch(() => {});
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    /**
     * 切换tab(服务)
     */
    onTabChange() {
      // 记录埋点
      this.utils.trackClick({ name: '切换精准服务', label: this.activeKey });
      this.choseRelease = null;
      this.filterItems = [];
      this.filterForm.title = null;
      const service = this.serviceList.find(item => item.service_name === this.activeKey);
      this.serviceId = service.service_id;
      this.getAccInfo();
      this.getReleaseList();
    },

    /**
     * 点击文件
     * @param {*} data
     */
    fileClick(data) {
      if (data.type === 'folder') {
        return;
      }
      if (data.graph.api_list === null && data.graph.grpc_list === null) {
        this.$message.warning('该文件未影响任何接口');
        return;
      }
      this.high_light_api_list = data.graph.api_list !== null ? [...data.graph.api_list] : [];
      this.high_light_grpc_list = data.graph.grpc_list !== null ? [...data.graph.grpc_list] : [];
      // focusNodeById(nodeId) 根据节点id在图谱中选中该节点并居中
      const { nodes, relationships } = data.graph;
      const _all_nodes = this.$refs.seeksRelationGraph.getNodes() || [];
      const _all_lines = this.$refs.seeksRelationGraph.getLinks() || [];
      _all_nodes.forEach(node => {
        // 链路节点渲染
        Accurate.nodeSetColor(
          node,
          nodes.some(n => node.id === n.id.toString())
        );
        // 关键函数节点渲染
        data.function_list.map(item => {
          if (node.id === item.id.toString()) {
            node.color = '#f56c6c';
            node.borderColor = '#f56c6c';
          }
        });
      });
      if (data.function_list.length > 0) {
        this.$refs.seeksRelationGraph.focusNodeById(data.function_list[0].id.toString());
      }
      _all_lines.forEach(line => {
        if (relationships.find(l => line.relations[0].data.id === l.id) !== undefined) {
          line.relations[0].color = '#e6a23c';
        }
      });
    },

    /**
     * 代码对比
     * @param {*} data
     */
    onCodeDiff(data) {
      this.modalVisible = true;
      this.diff = { ...data };
    },

    /**
     * 点击节点
     * @param {*} nodeObject
     * @param {*} $event
     */
    onNode(nodeObject, $event) {
      console.log('onNode:', nodeObject);
    },

    /**
     * 点击行
     * @param {*} lineObject
     * @param {*} linkObject
     * @param {*} $event
     */
    onLine(lineObject, linkObject, $event) {
      console.log('onLine:', lineObject);
    },

    /**
     * 复制路径
     * @param {*} path
     */
    copyPath(path) {
      const input = document.createElement('input');
      input.value = path;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy');
      document.body.removeChild(input);
      this.$message.success('路径复制成功');
    },

    onModalClose() {
      this.utils.trackClick({ name: '关闭精准对话框' });
    },

    async doCodeAnalyse() {
      let res;
      try {
        res = await Accurate.doTaskAnalyse({
          workflow_id: this.workflowId,
          service_name: this.activeKey
        });
        if (res) {
          this.$message.success('触发成功，请稍后再查看结果！');
        }
      } finally {
        console.log(res);
      }
    },

    /**
     * 显示生成case按钮
     * @param {*} item
     */
    showGenerateCase(item) {
      this.hoveredApi = item;
    },

    /**
     * 隐藏生成case按钮
     * @param {*} item
     */
    hideGenerateCase(item) {
      this.hoveredApi = null;
    },

    /**
     * 生成集成case
     * @param {*} item
     */
    async generateCase(item) {
      this.$message.info(`正在为 ${item} 生成集成case...`);
      const res = await Accurate.generateCase({
        workflow_id: this.workflowId,
        service_name: this.activeKey,
        path: item
      });
      // TODO: 实现生成集成case的逻辑
      console.log('生成集成case:', item);
      console.log('当前服务名称:', this.activeKey);
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .ant-modal-body {
  padding: 8px !important;
}
::v-deep .ant-tabs {
  .ant-tabs-bar {
    margin: 0px 0 8px 0 !important;
  }
}

.container {
  height: 75vh;
  display: flex;

  .container-card {
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 8px;
  }

  .file-container {
    width: 0;
    flex: 3;

    .file-tree {
      overflow-y: auto;
      height: calc(~'100% - 40px');
    }

    .custom-tree-node {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
      width: 100%;
    }

    .father .child {
      display: none;
    }

    .father:hover .child {
      display: block;
    }

    .icon {
      width: 1.2em;
      height: 1.2em;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
    }

    .node-title {
      width: 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1 1 auto;
      padding: 0 5px;
      overflow: hidden;
      font-weight: 600;
    }

    .create-line {
      color: #217645;
    }

    .delete-line {
      margin-left: 3px;
      color: #dd2b0e;
    }

    .suspect-flag {
      margin-left: 6px;
    }
  }

  .graph-container {
    flex: 7;
    width: 0;
    margin: 0 8px;
    display: flex;
    justify-content: center;

    .code-view {
      background-color: red;
    }

    .node-style {
      width: 95px;
      margin-top: 7px;
      margin-left: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .api-container {
    flex: 2;
    width: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .api-item {
      position: relative;
      margin-top: 5px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .tag {
      min-width: 255px;
    }
    .generate-case-btn {
      position: absolute;
      right: 0;
      z-index: 10;
      animation: fadeIn 0.2s ease-in-out;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

  .ai-progress {
    margin-left: 6px;
    display: flex;
    align-items: center;

    .ai-icon-loading {
      font-size: 38px;
      color: #1890ff;
      filter: drop-shadow(0 2px 4px rgba(24, 144, 255, 0.3));
      transition: all 0.3s ease;

      &:hover {
        filter: drop-shadow(0 4px 8px rgba(24, 144, 255, 0.5));
        transform: scale(1.05);
      }

      ::v-deep svg {
        animation: aiSpin 2s linear infinite;
      }
    }
  }

  @keyframes aiSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
      }
}

.ai-loading-container {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;

  .ai-loading {
    position: relative;
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .ai-circle {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid transparent;
    border-top-color: #1890ff;
    border-radius: 50%;
    animation: ai-spin 1.5s linear infinite;

    &:nth-child(2) {
      border-top-color: #52c41a;
      animation-delay: 0.5s;
    }

    &:nth-child(3) {
      border-top-color: #722ed1;
      animation-delay: 1s;
    }
  }

  .ai-text {
    font-size: 13px;
    font-weight: 500;
  }

  .ai-pulse {
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(24, 144, 255, 0.3) 0%, transparent 70%);
    border-radius: 50%;
    animation: ai-pulse 2s ease-in-out infinite;
  }
}

@keyframes ai-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes ai-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}
</style>
